
import { cn } from "@/lib/utils";

const Logo = ({ className, withText = false }: { className?: string; withText?: boolean }) => {
  return (
    <div className={cn("flex items-center gap-2.5 whitespace-nowrap", className)}>
      <div className="h-8 w-8 rounded-full bg-white flex items-center justify-center shrink-0">
        <img 
          src="/assets/icons/logo.png" 
          alt="Skutopia Academy Logo" 
          className="h-5 w-5 object-contain"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </div>
      {withText ? (
        <span className="text-[15px] font-bold tracking-tight leading-none">
          Skutopia <span className="font-medium opacity-80">Academy</span>
        </span>
      ) : null}
    </div>
  );
};

export default Logo;
